import { COOKIE_CLIENT_CLIENT_ENTRIES } from '@/_constants/cookies';
import {
  getCookie,
  setCookie,
  type CookieValueTypes,
} from 'cookies-next/client';

export const getClientEntryStatus = (clientEntryId: number): boolean => {
  const cookie: CookieValueTypes = getCookie(COOKIE_CLIENT_CLIENT_ENTRIES);

  if (!cookie || typeof cookie !== 'string') return false;

  try {
    const cookieParsed = JSON.parse(cookie);

    if (!(clientEntryId in cookieParsed)) {
      return false;
    }

    return Boolean(cookieParsed[clientEntryId]);
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const toggleClientEntry = (clientEntryId: number): void => {
  if (!clientEntryId) return;

  const cookie: CookieValueTypes = getCookie(COOKIE_CLIENT_CLIENT_ENTRIES);
  let status = { [clientEntryId]: true };

  try {
    const cookieParsed = !!cookie ? JSON.parse(cookie as string) : {};
    cookieParsed[clientEntryId] = !cookieParsed[clientEntryId];

    status = cookieParsed;
  } catch (error) {
    console.error(error);
  } finally {
    setCookie(COOKIE_CLIENT_CLIENT_ENTRIES, status);
  }
};
